import React from "react";
import { Pannellum } from "pannellum-react";
import { GAME_CONFIG } from "../config";

// SET INSTO BOTTLE POSITION FOR EACH STAGE HERE
const hotstpotStage1 = [
  {
    type: "custom",
    pitch: -32,
    yaw: -25,
    name: "hs2",
    cssClass: "custom-hotspot", // di meja
  },
  {
    type: "custom",
    pitch: -25,
    yaw: 150,
    name: "hs3",
    cssClass: "custom-hotspot",
  },
  {
    type: "custom",

    pitch: -25,
    yaw: -132,
    name: "hs1",
    cssClass: "custom-hotspot",
  },
];
const hotstpotStage1a = [
  {
    type: "custom",
    pitch: -9,
    yaw: 40,
    name: "hs2",
    cssClass: "custom-hotspot",
  },
  {
    type: "custom",
    pitch: -20, // vertical
    yaw: 180, // horizontal
    name: "hs1",
    cssClass: "custom-hotspot",
  },
  {
    type: "custom",
    pitch: -1,
    yaw: 280,
    name: "hs3",
    cssClass: "custom-hotspot",
  },
];
const hotstpotStage2 = [
  {
    type: "custom",
    pitch: -5,
    yaw: 120,
    name: "hs4",
    cssClass: "custom-hotspot-2",
  },
  {
    type: "custom",
    pitch: -20,
    yaw: 245,
    name: "hs5",
    cssClass: "custom-hotspot-2",
  },
  {
    type: "custom",
    pitch: -14,
    yaw: 0,
    name: "hs6",
    cssClass: "custom-hotspot-2",
  },
];
const hotstpotStage3 = [
  {
    type: "custom",
    pitch: -24,
    yaw: 280,
    name: "hs7",
    cssClass: "custom-hotspot-3",
  },
  {
    type: "custom",
    pitch: -40,
    yaw: 230,
    name: "hs8",
    cssClass: "custom-hotspot-3",
  },
  {
    type: "custom",
    pitch: -30,
    yaw: 70,
    name: "hs9",
    cssClass: "custom-hotspot-3",
  },
];

const panellumHotstpots = GAME_CONFIG.hasPrepStage
  ? {
      0: hotstpotStage1,
      1: hotstpotStage1a,
      2: hotstpotStage2,
      3: hotstpotStage3,
    }
  : {
      0: hotstpotStage1a,
      1: hotstpotStage2,
      2: hotstpotStage3,
    };

export default function GamePanorama({
  currentStageImg,
  handleDeleteHotspot,
  currentStage,
}) {
  let panellumHotstpot = panellumHotstpots[currentStage];

  return (
    <div className="game-engine__panorama">
      <Pannellum
        height={"100%"}
        image={currentStageImg}
        pitch={10}
        yaw={180}
        hfov={110}
        autoLoad
        showZoomCtrl={false}
        onLoad={() => {
          console.log("panorama loaded");
        }}
      >
        {panellumHotstpot.map((item, index) => {
          return (
            <Pannellum.Hotspot
              key={index}
              type={item.type}
              pitch={item.pitch}
              yaw={item.yaw}
              handleClick={(e) => handleDeleteHotspot(e, index)}
              name={item.name}
              cssClass={item.cssClass}
            />
          );
        })}
      </Pannellum>
    </div>
  );
}
